<template functional>
  <section class="bg-yellow">
    <div class="content">
      <h1 class="fs-l fw-l">Hi, I am Sašo</h1>
      <h2 class="fs-m">Engineer, Designer, Developer</h2>
      <h2 class="fs-m fw-l">
        But why is this <img src="@/assets/img/Bee.svg" alt="Bee icon" /> on the
        page? Because bees are important! Check my creations and projects below.
      </h2>
    </div>
  </section>
</template>

<script>
export default {
  name: "TheTitleSection"
};
</script>

<style lang="scss" scoped>
@import "@/variables";

section {
  .content {
    h1 {
      margin-bottom: 1rem;
    }

    h2:last-child {
      margin-top: 4rem;
    }
  }

  img {
    width: 1em;
  }

  @media screen and (min-width: $screen-s) {
    .content {
      width: 500px;
    }
  }

  @media screen and (min-width: $screen-m) {
    .content {
      width: 600px;
    }
  }

  @media screen and (min-width: $screen-l) {
    .content {
      width: 700px;
    }
  }

  @media screen and (min-width: $screen-xl) {
    .content {
      width: 900px;
    }
  }
}
</style>
